export const TUTORIAL_BOARD = {
    "columns": [
        {
            "points": [
                {
                    "x": 0,
                    "y": 0,
                    "letter": "A"
                },
                {
                    "x": 0,
                    "y": 1,
                    "letter": "I"
                },
                {
                    "x": 0,
                    "y": 2,
                    "letter": "I"
                },
                {
                    "x": 0,
                    "y": 3,
                    "letter": "U"
                },
                {
                    "x": 0,
                    "y": 4,
                    "letter": "O"
                },
                {
                    "x": 0,
                    "y": 5,
                    "letter": "O"
                }
            ]
        },
        {
            "points": [
                {
                    "x": 1,
                    "y": 0,
                    "letter": "I"
                },
                {
                    "x": 1,
                    "y": 1,
                    "letter": "R"
                },
                {
                    "x": 1,
                    "y": 2,
                    "letter": "C"
                },
                {
                    "x": 1,
                    "y": 3,
                    "letter": "U"
                },
                {
                    "x": 1,
                    "y": 4,
                    "letter": "E"
                },
                {
                    "x": 1,
                    "y": 5,
                    "letter": "S"
                },
                {
                    "x": 1,
                    "y": 6,
                    "letter": "D"
                }
            ]
        },
        {
            "points": [
                {
                    "x": 2,
                    "y": 0,
                    "letter": "I"
                },
                {
                    "x": 2,
                    "y": 1,
                    "letter": "U"
                },
                {
                    "x": 2,
                    "y": 2,
                    "letter": "T"
                },
                {
                    "x": 2,
                    "y": 3,
                    "letter": "Y"
                },
                {
                    "x": 2,
                    "y": 4,
                    "letter": "I"
                },
                {
                    "x": 2,
                    "y": 5,
                    "letter": "L"
                }
            ]
        },
        {
            "points": [
                {
                    "x": 3,
                    "y": 0,
                    "letter": "J"
                },
                {
                    "x": 3,
                    "y": 1,
                    "letter": "N"
                },
                {
                    "x": 3,
                    "y": 2,
                    "letter": "U"
                },
                {
                    "x": 3,
                    "y": 3,
                    "letter": "P"
                },
                {
                    "x": 3,
                    "y": 4,
                    "letter": "N"
                },
                {
                    "x": 3,
                    "y": 5,
                    "letter": "N"
                },
                {
                    "x": 3,
                    "y": 6,
                    "letter": "I"
                }
            ]
        },
        {
            "points": [
                {
                    "x": 4,
                    "y": 0,
                    "letter": "P"
                },
                {
                    "x": 4,
                    "y": 1,
                    "letter": "O"
                },
                {
                    "x": 4,
                    "y": 2,
                    "letter": "O"
                },
                {
                    "x": 4,
                    "y": 3,
                    "letter": "Z"
                },
                {
                    "x": 4,
                    "y": 4,
                    "letter": "S"
                },
                {
                    "x": 4,
                    "y": 5,
                    "letter": "O"
                }
            ]
        }
    ]
}